import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';


@Component({
  selector: 'ebb-portal-dialog-paform-warn',
  templateUrl: './dialog-paform-warn.component.html'
})
export class DialogPafWarnComponent implements OnInit {
  constructor(
    public readonly dialogRef: MatDialogRef<DialogPafWarnComponent>,
  ) { }

  ngOnInit() {
  }

  public onClickOk(): void {
    this.dialogRef.close();
  }

}
